import { render, staticRenderFns } from "./subsidiary.vue?vue&type=template&id=5cb7734f&scoped=true&"
import script from "./subsidiary.vue?vue&type=script&lang=js&"
export * from "./subsidiary.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary.vue?vue&type=style&index=0&id=5cb7734f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb7734f",
  null
  
)

export default component.exports